import { useApolloClient } from 'application/providers/DataProvider';
import { useAdCampaignCreate, useAdCampaigns } from '@entities/adCampaign';

const useAdCreateModalPresenter = () => {
  const client = useApolloClient();
  const [createAdCampaign, adCampaignCreateResult] = useAdCampaignCreate();
  const [, adCampaignsResult] = useAdCampaigns();
  const adCampaignCreateLoading = adCampaignCreateResult.loading;

  const clearAdCampaigns = () => {
    client.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'adcampaignsPaginationQuery',
      broadcast: false,
    });
  };

  const isLoading = adCampaignCreateLoading || adCampaignsResult.loading;

  return {
    createAdCampaign,
    isLoading,
    clearAdCampaigns,
  };
};

export default useAdCreateModalPresenter;
